export default __webpack_public_path__ + "static/media/placehoder-avatar.44fac21d.svg";